// Import react
import React, { useState } from "react";

// Import states, contexts, and CSS
import { useActiveUser } from "../../store/activeUserContext";

import { Form, Button, Col, Row } from "react-bootstrap";
import { XCircle, Pencil } from "react-bootstrap-icons";
import Modal from "react-bootstrap/Modal";

const ItemListRow = ({ index, item, setUpdate, setFilter, columnsToShow }) => {
  // Get user data from context
  const { activeUser } = useActiveUser();

  // Get variables from local storage
  const userId = activeUser._id;
  const token = localStorage.getItem("token");

  const visibleFields = columnsToShow
    .filter((col) => col.show)
    .map((col) => col.field);

  const {
    _id,
    itemId,
    itemCode,
    itemType,
    itemName,
    itemDescription,
    itemCategory1,
    itemCategory2,
    itemCategory3,
    itemCategory4,
    itemCategory5,
    itemSize,
    itemBrand,
    itemWeight,
  } = item;

  const [editItem, setEditItem] = useState({
    itemCode: itemCode,
    itemType: itemType,
    itemName: itemName,
    itemDescription: itemDescription,
    itemCategory1: itemCategory1,
    itemCategory2: itemCategory2,
    itemCategory3: itemCategory3,
    itemCategory4: itemCategory4,
    itemCategory5: itemCategory5,
    itemSize: itemSize,
    itemBrand: itemBrand,
    itemWeight: itemWeight,
  });

  const [modalShow, setModalShow] = useState(false); // Modal visibility state

  const handleDeleteItem = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/item/${_id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        console.log("Articolo eliminato correttamente");
      } else {
        console.error("Errore durante la eliminazione dell'articolo");
      }
    } catch (error) {
      console.error("Errore durante la richiesta DELETE:", error);
    }
  };

  const handleEditItem = async () => {
    setFilter("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/item/users/${userId}/item/${_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(editItem),
        }
      );

      if (response.ok) {
        console.log("Articolo modificato correttamente");
      } else {
        console.error("Errore durante la modifica dell'articolo");
      }
    } catch (error) {
      console.error("Errore durante la richiesta PUT:", error);
    } finally {
      setUpdate((prevUpdate) => !prevUpdate);
      setEditItem({
        itemCode: "",
        itemType: "",
        itemName: "",
        itemDescription: "",
        itemCategory1: "",
        itemCategory2: "",
        itemCategory3: "",
        itemCategory4: "",
        itemCategory5: "",
        itemSize: "",
        itemBrand: "",
        itemWeight: "",
      });
    }
  };

  const handleChangeEdit = (e) => {
    setEditItem({ ...editItem, [e.target.name]: e.target.value });
  };

  // Function to close the Modal
  const handleCloseModal = () => setModalShow(false);

  return (
    <>
      <tr key={index}>
        <td>{itemId}</td>
        <td>{itemCode}</td>
        {visibleFields.map((field) => (
          <td key={field}>{item[field]}</td>
        ))}
        <td>
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => setModalShow(true)}
          >
            <Pencil size={16} />
          </Button>
          <Button variant="outline-danger" size="sm" onClick={handleDeleteItem}>
            <XCircle size={16} />
          </Button>
        </td>
      </tr>

      {/* Modal Component */}
      <Modal
        show={modalShow} // Bind the Modal visibility to modalShow
        onHide={handleCloseModal} // Close modal when user clicks close button
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Modifica Articolo: {itemId}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="align-items-center mb-3">
              <Col md={2}>
                <Form.Label>Item Code *</Form.Label>
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Enter item ode"
                  name="itemCode"
                  value={editItem.itemCode}
                  onChange={handleChangeEdit}
                  disabled
                  readOnly
                />
              </Col>
              <Col md={2}>
                <Form.Label>Category 1</Form.Label>
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Enter item category 1"
                  name="itemCategory1"
                  value={editItem.itemCategory1}
                  onChange={handleChangeEdit}
                />
              </Col>
            </Row>
            <Row className="align-items-center mb-3">
              <Col md={2}>
                <Form.Label>Item Type *</Form.Label>
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Enter item type"
                  name="itemType"
                  value={editItem.itemType}
                  onChange={handleChangeEdit}
                />
              </Col>
              <Col md={2}>
                <Form.Label>Category 2</Form.Label>
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Enter item category 2"
                  name="itemCategory2"
                  value={editItem.itemCategory2}
                  onChange={handleChangeEdit}
                />
              </Col>
            </Row>

            <Row className="align-items-center mb-3">
              <Col md={2}>
                <Form.Label>Item Name *</Form.Label>
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Enter item name"
                  name="itemName"
                  value={editItem.itemName}
                  onChange={handleChangeEdit}
                />
              </Col>
              <Col md={2}>
                <Form.Label>Category 3</Form.Label>
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Enter item category 3"
                  name="itemCategory3"
                  value={editItem.itemCategory3}
                  onChange={handleChangeEdit}
                />
              </Col>
            </Row>
            <Row className="align-items-center mb-3">
              <Col md={2}>
                <Form.Label>Item Description</Form.Label>
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Enter item description"
                  name="itemDescription"
                  value={editItem.itemDescription}
                  onChange={handleChangeEdit}
                />
              </Col>
              <Col md={2}>
                <Form.Label>Category 4</Form.Label>
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Enter item category 4"
                  name="itemCategory4"
                  value={editItem.itemCategory4}
                  onChange={handleChangeEdit}
                />
              </Col>
            </Row>
            <Row className="align-items-center mb-3">
              <Col md={2}>
                <Form.Label>Item Size</Form.Label>
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Enter item size"
                  name="itemSize"
                  value={editItem.itemSize}
                  onChange={handleChangeEdit}
                />
              </Col>
              <Col md={2}>
                <Form.Label>Category 5</Form.Label>
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Enter item category 5"
                  name="itemCategory5"
                  value={editItem.itemCategory5}
                  onChange={handleChangeEdit}
                />
              </Col>
            </Row>
            <Row className="align-items-center mb-3">
              <Col md={2}>
                <Form.Label>Item Weight</Form.Label>
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Enter item weight"
                  name="itemWeight"
                  value={editItem.itemWeight}
                  onChange={handleChangeEdit}
                />
              </Col>
              <Col md={2}>
                <Form.Label>Brand</Form.Label>
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Enter item brand"
                  name="itemBrand"
                  value={editItem.itemBrand}
                  onChange={handleChangeEdit}
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleEditItem}>
            Save{" "}
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ItemListRow;
